<template>
  <div>
    <div>
      <div class="date col-2">
        <p class="mb-0 date-text">
          <i class="fa fa-circle date-circle " />
          {{ logGroup.date }}
        </p>
      </div>
    </div>
    <logs-item
      v-for="log in logGroup.logs"
      :key="log.id"
      :log="log"
    />
  </div>
</template>

<script>
import LogsItem from './LogsItem';

export default {
  components: {
    LogsItem,
  },
  props: {
    logGroup: {
      type: Object,
      default: () => [],
    },
    claim: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style>
.date {
  padding-left: 3px !important;
  background-color: #808d98;
  border-radius: 10px;
  margin-left: 10px;
  max-width: 84px;
}

.date-circle {
  margin: 3px;
  color: white;
}

.date-text {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 11px;
  font-weight: 500;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/claims/LogsGroup.vue